// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"647":"6e44af0b","894":"6e44af0b"}[chunkId] + ".chunk.css";
};